import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';
import { NavItem } from 'src/app/model/nav-item';
import { User } from 'src/app/model/user';
import { FclLoginService } from 'src/app/services/fcllogin.service';
import { NavService } from 'src/app/services/nav.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ElementRef } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { ItemService as ItemSvc1 } from 'src/app/services/reverse/item.service';
import { ItemService as ItemSvc2 } from 'src/app/services/item.service';

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss']
})
export class MenuListItemComponent implements OnInit, AfterViewInit {

  expanded = false;
  @Input() item: NavItem;
  @Input() depth: number;
  @Input() isSmallScreen = false; 
  showmenu = false;

  constructor(
    private translateService: TranslateService,
    public navService: NavService,
    public router: Router,
    public oktaAuth: OktaAuthService,
    private fclLoginService: FclLoginService,
    private el: ElementRef,
    public itemservice: ItemSvc1,
    public itemSvc: ItemSvc2) {

    if (this.depth === undefined) {
      this.depth = 0;
    }

  }

  ngOnInit(): void {
    // Check if this menu item should be expanded based on the current route
    this.checkIfShouldExpand();

    // Subscribe to router events to handle direct navigation to child routes
    this.router.events.subscribe(() => {
      this.checkIfShouldExpand();
    });
  }

  private checkIfShouldExpand(): void {
    // First check if any direct child route is active
    if (this.item?.children) {
      const hasActiveChild = this.item.children.some(child => {
        // Check if direct child route is active
        if (child.route && this.router.isActive(child.route, true)) {
          return true;
        }
        // Check if any grandchild route is active
        if (child.children) {
          return child.children.some(grandChild => 
            grandChild.route && this.router.isActive(grandChild.route, true)
          );
        }
        return false;
      });

      if (hasActiveChild) {
        this.expanded = true;
      }
    }

    // Also check selected menu ID as before
    if (this.navService.selectedMenuId !== undefined) {
      if (this.item !== undefined && this.item.children && this.item.children.length) {
        for (const curItem of this.item.children) {
          if (this.navService.selectedMenuId === curItem.id) {
            this.expanded = true;
            break;
          }

          if (curItem.children && curItem.children.length) {
            for (const parent of curItem.children) {
              if (this.navService.selectedMenuId === parent.id) {
                this.expanded = true;
                break;
              }
            }
          }
        }
      }
    }
  }

  ngAfterViewInit() {
    this.showmenu = false;
    setTimeout(() => {
      this.scrollActiveItemIntoView();
    }, 200); 
    this.showmenu = true;
  }

  onItemSelected(item: NavItem) {
    this.itemservice.filterRequest = {
      itemId: '',
      itemDesc: '',
      itmDelFlag: ''
    };
    this.itemSvc.filterRequest = '';
    if (!item.children || !item.children.length) {
      if (this.isSmallScreen) {
        this.navService.closeNav();
      }
      this.navService.setMenuPermissions(item.id);
      this.navService.setMenuName(item.displayName);
      let route = item.route;
      this.navService.navigationPath = route;
      if (route.startsWith('report_')) {
        route = route.substring('report_'.length, route.length);
        route = environment.spotFileURL + route;
        console.log('environment.spotFileURL:'+environment.spotFileURL);
        console.log('route:'+route);
        this.openDashboardUrl(route);
      } else if (route.startsWith('powerbi/')) {       
        localStorage.removeItem('powerbi-report');
        localStorage.setItem('powerbi-report', route );
        setTimeout(() => {
          this.router.navigate(['operations/reports', item.id]);
        }, 500);
      } else {
        this.router.navigate([route]);
      }


    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    } else {
      // When a child item is selected, make sure all parent menus stay expanded
      let parentElement = this.el.nativeElement.parentElement;
      while (parentElement) {
        const parentComponent = parentElement.closest('app-menu-list-item');
        if (parentComponent) {
          try {
            const context = parentComponent['__ngContext__'];
            const parentItemComponent = context && typeof context.getInstance === 'function' ? context.getInstance() : null;
            if (parentItemComponent) {
              parentItemComponent.expanded = true;
            }
          } catch (e) {
            // Silently fail if we can't access parent component
          }
          parentElement = parentComponent.parentElement;
        } else {
          break;
        }
      }
    }
  }

  async openDashboardUrl(spotFireReport: string) {
    //  console.log('********:spotFireReport::' + spotFireReport);
    const accessToken = await this.oktaAuth.getAccessToken();
    const xhr = new XMLHttpRequest();
    xhr.open('GET', spotFireReport, true);
    xhr.withCredentials = true;
    xhr.onprogress = () => {
      // console.log('LOADING: ', xhr.status);
    };
    xhr.onload = () => {
      if (xhr.readyState === xhr.DONE) {
        if (xhr.status === 200) {
          // console.log('SUCCESS');
        }
      }
    };
    const user = this.fclLoginService.getUser();
    this.setSpotFireRequestHeader(xhr, user, accessToken);
    xhr.send(null);
    this.delay(2000).then(any => {
      if (xhr.status === 200) { 
        window.open(spotFireReport, '_blank');
      } else {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', spotFireReport, true);
        this.setSpotFireRequestHeader(xhr, user, accessToken);
        xhr.withCredentials = true;
        xhr.send(null);
        this.delay(2000).then(any => {
          window.open(spotFireReport, '_blank');
        });
      }
    });

  }

  private setSpotFireRequestHeader(xhr: XMLHttpRequest, user: User, accessToken: string) {
    if (this.fclLoginService.getUserType() === 'I') {
      xhr.setRequestHeader('OBLIX_UID', user.fedExId);
      xhr.setRequestHeader('jwtToken', accessToken);
    } else if (this.fclLoginService.getUserType() === 'E') {
      const spotFireUserId = user.fclUuid;
      xhr.setRequestHeader('OBLIX_UID', spotFireUserId);
      xhr.setRequestHeader('fdx_login', spotFireUserId);
      xhr.setRequestHeader('fcl_uuid', spotFireUserId);
    }
  }

  callSpotFire() {

    const xhr = new XMLHttpRequest();
    xhr.open('GET', environment.spotFileURL, true);
    xhr.withCredentials = true;
    xhr.onprogress = () => {
      // console.log('ngOnInit LOADING: ', xhr.status);
    };
    xhr.onload = () => {
      if (xhr.readyState === xhr.DONE) {
        if (xhr.status === 200) {
          //  console.log('ngOnInit SUCCESS');
        }
      }
    };

    xhr.send(null);
  }

  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(() => resolve(), ms)).then(() => console.log(ms, ' seconds done'));
  }

  private scrollActiveItemIntoView(): void {
    const activeItem = this.el.nativeElement.querySelector('.active-menu');

    if (activeItem) {
      activeItem.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'nearest' });
    } 
  }


}
